import * as types from './constants';

export const selectReader = (readers, strategy) => ({
  type: types.SELECT_READER,
  payload: readers,
  strategy,
});

export const selectReaderDone = (reader, strategy) => ({
  type: types.SELECT_READER_DONE,
  payload: reader,
  strategy,
});

export const selectReaderCancel = strategy => ({
  type: types.SELECT_READER_CANCEL,
  strategy,
});

export const noAvailableReaders = strategy => ({
  type: types.NO_AVAILABLE_READERS,
  strategy,
});

export const readerConnectSuccess = strategy => ({
  type: types.READER_CONNECT_SUCCESS,
  strategy,
});

export const discoverReaders = strategy => ({
  type: types.DISCOVER_READERS,
  strategy,
});

export const setExternalPaymentInfo = payload => ({
  type: types.SET_EXTERNAL_PAYMENT_INFO,
  payload,
});

export const readyToPay = () => ({
  type: types.READY_TO_PAY,
});

export const readyToRefund = () => ({
  type: types.READY_TO_REFUND,
});
